import React from 'react'
import Footer from '../Home/Footer'
import ReactHTMLParser from 'react-html-parser'

export default (props) => (
  <div style={props.style} id="interview-container">
    <header className="l-header-lower interview-header">
      <div className="header-bg" />
      <div className="header-wrap">
        <div className="header-logo">
          <h1>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 614 100"><title>株式会社ソルパック</title><path class="logo-path-text" fill="#ffffff" d="M378.2 80.2V68.1H334V17.2h-14.7v63zm123.7-63h-15.3l-33.5 62.9h14.4l7.1-13.4h39.2l7.1 13.4h14.4l-33.4-62.9zm-20.8 37.5l13.2-24.8 13.2 24.8h-26.4zm-184.7-30c-7.2-6.2-17.3-9.5-29.4-9.5-27.8 0-40.2 16.8-40.2 33.5 0 9.5 3.8 18 10.8 24 7.2 6.2 17.3 9.5 29.4 9.5 27.8 0 40.2-16.8 40.2-33.5 0-9.5-3.8-18-10.8-24zM267 70.1c-7.6 0-14.1-2.1-18.6-6.1-4.4-3.8-6.8-9.3-6.8-15.4 0-10.7 7.9-21.4 25.4-21.4 7.6 0 14.1 2.1 18.6 6.1 4.4 3.8 6.8 9.3 6.8 15.4.1 10.7-7.8 21.4-25.4 21.4zm124.6-52.9v62.9H405V58.7h32.2c11.4 0 20.8-9.3 20.8-20.8s-9.3-20.8-20.8-20.8h-45.6zM405 46.7V29.3h31.2c4.6 0 8.3 3.9 8.3 8.7s-3.7 8.7-8.3 8.7H405zm195.3 13.5c-3.9 5.7-11 9.9-22 9.9-7.6 0-14.1-2.1-18.6-6.1-4.4-3.8-6.8-9.3-6.8-15.4 0-10.7 7.9-21.4 25.4-21.4 7.6 0 14.1 2.1 18.6 6.1 1.3 1.1 2.4 2.4 3.4 3.8l13-6.1c-1.5-2.3-3.4-4.5-5.6-6.3-7.2-6.2-17.3-9.5-29.4-9.5-27.8 0-40.2 16.8-40.2 33.5 0 9.5 3.8 18 10.8 24 7.2 6.2 17.3 9.5 29.4 9.5 17.5 0 28.9-6.7 35-15.8l-13-6.2zM183 41.3c24.4 0 35.8 9 35.8 20.1S207.5 82.2 183 82.2c-14.4 0-27.7-3-37.8-9.3l8.1-10.2c6.5 3.7 17.9 7.4 29.3 7.4 17.4 0 20.8-3.3 20.8-7.4s-3.3-7.4-20.8-7.4c-24.2-.1-35.5-9-35.5-20.1 0-11.1 11.4-20.1 35.8-20.1 13.6 0 26.2 4.2 34.7 9.8l-8 10c-4.4-3.7-14.2-7.7-27-7.7-17.4 0-20.8 3.1-20.8 7s3.3 7 20.8 7h.4z"/><path fill="#0057b5" d="M84.3 52.2v17.4l-30.4 8.7L.6 63v30.5l22.9 6.5V87l30.4 8.6 53.3-15.2V45.6L46.3 28.3v13z"/><path fill="#2880ce" d="M107.2 15.2L53.9 0 .6 15.2V50l60.9 17.4V54.3l-38-10.8V26.1l30.4-8.7 53.3 15.2z"/></svg>
          </h1>
          <p>株式会社ソルパック　経験者採用ページ</p>
        </div>
        <div className="header-return"><a onClick={props.backToHome}>
            <svg className="svgIllust" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <title />
              <path d="M333.653,41.349H48.769c-7.187,0-13.031,5.848-13.031,13.027v62.129c0,7.184,5.844,13.028,13.031,13.028h286.223c45.484,0,84.328,34.156,88.43,77.758c2.313,24.539-5.516,48.051-22.039,66.199c-16.305,17.918-39.508,28.191-63.645,28.191H199.769V230.76c0-5.386-4.382-9.77-9.774-9.77c-1.859,0-3.683,0.531-5.25,1.539L4.523,337.525C1.695,339.322,0.004,342.4,0,345.752c-0.004,3.352,1.684,6.434,4.512,8.242L184.75,469.119c1.574,1.004,3.39,1.532,5.246,1.532c5.391,0,9.774-4.383,9.774-9.77v-71.016h137.969c47.727,0,92.294-18.988,125.489-53.465c33.176-34.45,50.449-79.73,48.645-127.504C508.379,116.509,428.43,41.349,333.653,41.349z" />
            </svg></a></div>
        <nav className="header-nav">
          <ul>
            <li className="entry"><a target="_blank" href={props.formUrl} rel="noopener noreferrer">ENTRY</a></li>
          </ul>
        </nav>
      </div>
    </header>
    <main className="l-main theme-single">
      <article className="l-article">
        <section className="interviews_lower">
          <div className="interviews_lower_first background-interview">
            <div className="section_hexagon" />
            <div className="section_contents">
              <div className="visual_group">
								<div className="visual interview-img" style={{
                  visibility: 'hidden'
                }}>
                  <img src="" alt=""/>
                </div>
							</div>
              <div className="textarea">
                <div className="box interview-name">
                  <div className="name">
                    <h3>{props.data.first.name}</h3>
                  </div>
                  <div className="day brackets">
                    <p className="year_txt">入社年</p>
                    <p className="year">{props.data.first.year}</p>
                  </div>
                </div>
                <div className="job interview-job">
                  <p>{props.data.first.job}</p>
                </div>
                <p className="title animation-text-top"><strong>{ReactHTMLParser(props.data.first.title)}</strong></p>
                <p className="subtitle animation-text-top"><strong>{ReactHTMLParser(props.data.first.subtitle)}</strong></p>
                <p className="text animation-text-bottom">{ReactHTMLParser(props.data.first.text)}</p>
              </div>
            </div>
          </div>
          <div className="interviews_lower_second">
            <div className="group">
              <div className="visual"><img src={`images/interviews/${props.data.second.visual}`} alt=""/></div>
              <div className="textarea">
                <p className="subtitle"><strong>{ReactHTMLParser(props.data.second.subtitle_1)}</strong></p>
                <p className="text">{ReactHTMLParser(props.data.second.text_1)}</p>
              </div>
            </div>
            <div className="textgroup">
                <p className="subtitle"><strong>{ReactHTMLParser(props.data.second.subtitle_2)}</strong></p>
                <p className="text">{ReactHTMLParser(props.data.second.text_2)}</p>
            </div>
            <div className="textgroup">
                <p className="subtitle"><strong>{ReactHTMLParser(props.data.second.subtitle_3)}</strong></p>
                <p className="text">{ReactHTMLParser(props.data.second.text_3)}</p>
            </div>
            <div className="textgroup">
                <p className="subtitle"><strong>{ReactHTMLParser(props.data.second.subtitle_4)}</strong></p>
                <p className="text">{ReactHTMLParser(props.data.second.text_4)}</p>
            </div>
          </div>
          <div className="interviews_lower_return">
            <div className="return"><a onClick={props.backToHome}>
                <svg className="svgIllust" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <title />
                  <path d="M333.653,41.349H48.769c-7.187,0-13.031,5.848-13.031,13.027v62.129c0,7.184,5.844,13.028,13.031,13.028h286.223c45.484,0,84.328,34.156,88.43,77.758c2.313,24.539-5.516,48.051-22.039,66.199c-16.305,17.918-39.508,28.191-63.645,28.191H199.769V230.76c0-5.386-4.382-9.77-9.774-9.77c-1.859,0-3.683,0.531-5.25,1.539L4.523,337.525C1.695,339.322,0.004,342.4,0,345.752c-0.004,3.352,1.684,6.434,4.512,8.242L184.75,469.119c1.574,1.004,3.39,1.532,5.246,1.532c5.391,0,9.774-4.383,9.774-9.77v-71.016h137.969c47.727,0,92.294-18.988,125.489-53.465c33.176-34.45,50.449-79.73,48.645-127.504C508.379,116.509,428.43,41.349,333.653,41.349z" />
                </svg></a></div>
          </div>
        </section>
      </article>
    </main>
    <Footer isModalFooter={true} />
  </div>
)


// WEBPACK FOOTER //
// ./src/Interview/Container.js